import {Camera, Mesh, PlaneGeometry, Scene, ShaderMaterial, Texture, Vector2, Vector4, WebGLRenderTarget} from 'three'

import {getRenderer} from '../_commonObjects'

export default class DitheringAnimation {
  dimensions: Vector2 = new Vector2(1, 1)
  fbo: WebGLRenderTarget = new WebGLRenderTarget(1, 1)
  scene: Scene = new Scene()
  camera: Camera = new Camera()
  uniforms: {
    uTime: {value: number}
    uResolution: {value: Vector2}
    uProgress: {value: Vector4}
  } = {
    uTime: {value: Math.random() * 100},
    uResolution: {value: new Vector2(1, 1)},
    uProgress: {value: new Vector4(0, 0, 0, 0)},
  }
  constructor(width: number, height: number, fragmentShader: string, ditheringTexture: Texture) {
    this.resize(width, height)

    const geometry = new PlaneGeometry(2, 2)
    const material = new ShaderMaterial({
      vertexShader: `
        void main() {
          gl_Position = vec4(position, 1.0);
        }
      `,
      fragmentShader,
      uniforms: {
        ...this.uniforms,
        uDitheringTexture: {value: ditheringTexture},
      },
      depthTest: false,
      depthWrite: false,
    })

    const plane = new Mesh(geometry, material)
    this.scene.add(plane)
  }

  resize(width: number, height: number) {
    this.dimensions.set(width, height)
    this.dimensions.x = Math.floor(this.dimensions.x * 4.0) / 4.0
    this.dimensions.y = Math.floor(this.dimensions.y * 4.0) / 4.0

    this.fbo.setSize(this.dimensions.x, this.dimensions.y)
    this.uniforms.uResolution.value.set(this.dimensions.x, this.dimensions.y)
  }

  render(delta: number, _delta: number) {
    const renderer = getRenderer()
    if (!renderer) return
    this.uniforms.uTime.value += delta

    const progress = this.uniforms.uProgress.value
    progress.x += (1.0 - progress.x) * Math.min(1, _delta * 1.6) // fade in
    renderer.setRenderTarget(this.fbo)
    renderer.render(this.scene, this.camera)
  }
}
